export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9809.f0dc495c.jpg";